export enum UnassignEntityTagErrorcodes {
  UNASSIGN_TAG_FROM_ENTITY_IS_ONLY_SUPPORTED_FOR_PRODUCT = 'UNASSIGN_TAG_FROM_ENTITY_IS_ONLY_SUPPORTED_FOR_PRODUCT',
  UNASSIGN_TAG_FROM_ENTITY_IS_NOT_ALLOWED_FOR_BASIC_LICENSE_TYPE = 'UNASSIGN_TAG_FROM_ENTITY_IS_NOT_ALLOWED_FOR_BASIC_LICENSE_TYPE',
  UNASSIGN_TAG_FROM_ENTITY_VALIDATION_ERROR = 'UNASSIGN_TAG_FROM_ENTITY_VALIDATION_ERROR',
  UNASSIGN_TAG_FROM_ENTITY_TAG_NOT_ASSIGNED = 'UNASSIGN_TAG_FROM_ENTITY_TAG_NOT_ASSIGNED',
}

export const UnassignEntityTagErrorcodesTranslationKeyMap = {
  [UnassignEntityTagErrorcodes.UNASSIGN_TAG_FROM_ENTITY_IS_ONLY_SUPPORTED_FOR_PRODUCT]:
    'unassignForProducts',
  [UnassignEntityTagErrorcodes.UNASSIGN_TAG_FROM_ENTITY_IS_NOT_ALLOWED_FOR_BASIC_LICENSE_TYPE]:
    'unassignTagNotAllowed',
  [UnassignEntityTagErrorcodes.UNASSIGN_TAG_FROM_ENTITY_VALIDATION_ERROR]: 'companyNotFound',
  [UnassignEntityTagErrorcodes.UNASSIGN_TAG_FROM_ENTITY_TAG_NOT_ASSIGNED]: 'tagNotAssigned',
};
